import { useNavigate } from "react-router-dom";
import "../App.css";
import TopNav from "../components/TopNav";

function AuthPage() {
  const navigate = useNavigate();

  return (
    <div className="auth-container">
      <TopNav />

      <div className="auth_section">
        <h1 className="auth-heading">Welcome to WorkMart</h1>
        <p className="auth-description">
          WorkMart helps you connect with local jobs and services faster.
        </p>

        <ul className="auth-features">
          <li>Apply for jobs online instantly</li>
          <li>Message directly with employers and service providers</li>
          <li>Save jobs or services to your personal wish list</li>
        </ul>

        <div className="auth-btn-group">
          <button className="auth-btn login" onClick={() => navigate("/login")}>
            Login
          </button>
          <button
            className="auth-btn register"
            onClick={() => navigate("/register")}
          >
            Register
          </button>
        </div>
      </div>
    </div>
  );
}

export default AuthPage;
